module.exports = __webpack_public_path__ + "static/media/sheikhupura.3e621c6a.svg";